import { getLogoPrimary } from "./getLogoPrimary";
import { getLogoMaestro } from "./getLogoMaestro";
import { getLogoPoweredBy } from "./getLogoPoweredBy";
import { getLogoMichelin } from "./getLogoMichelin";
export var buildThemeLogos = function buildThemeLogos(type) {
  return {
    primary: getLogoPrimary(type),

    /**
     * @deprecated prefer Michelin branding
     */
    maestro: getLogoMaestro(type),

    /**
     * @deprecated prefer Michelin branding
     */
    poweredBy: getLogoPoweredBy(type),
    michelin: getLogoMichelin()
  };
};